import { useMutation } from '@tanstack/react-query';

import { authTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import storage from '@/utils/storage';

export const signIn: authTypes.SignIn = (data) => {
  return axios.post(`/accounts/sign-in`, data);
};

type UseSignInOptions = {
  config?: MutationConfig<typeof signIn>;
};

export function useSignIn({ config }: UseSignInOptions = {}) {
  return useMutation({
    onSuccess: ({ token }) => {
      storage.setToken(token);
      // Unlock is bound to the previous JWT — drop stale per-tab token on re-login.
      storage.clearAnalyticsBaseUnlockToken();
      queryClient.removeQueries({ queryKey: ['analytics-base-experts'] });
      queryClient.removeQueries({ queryKey: ['analytics-base'] });
      queryClient.invalidateQueries(['account-me']);
    },
    ...config,
    mutationFn: signIn,
  });
}
